export const Proteins = {
    PECHUGAPOLLO: {
        name: "Pechuga de pollo",
        netMacro: 22,
        totalWeight: 100
    },
    ATUN: {
        name: "Atún natural",
        netMacro: 22,
        totalWeight: 100
    },
    TERNERA: {
        name: "Ternera magra",
        netMacro: 22,
        totalWeight: 100
    },
    CERDO: {
        name: "Carne de cerdo magro",
        netMacro: 22,
        totalWeight: 100
    },
    SALMON: {
        name: "Salmón",
        netMacro: 22,
        totalWeight: 100
    },
    PULPO: {
        name: "Pulpo",
        netMacro: 22,
        totalWeight: 150
    },
    SARDINAS: {
        name: "Sardinas",
        netMacro: 22,
        totalWeight: 100
    },
    GAMBAS: {
        name: "Gambas peladas",
        netMacro: 22,
        totalWeight: 120
    },
    PESCADO_BLANCO: {
        name: "Pescado blanco",
        netMacro: 22,
        totalWeight: 120
    },
    PAVO: {
        name: "Pavo cocido",
        netMacro: 22,
        totalWeight: 120
    },
    JAMON_COCIDO: {
        name: "Jamón cocido",
        netMacro: 22,
        totalWeight: 120
    },
    JAMON_SERRANO: {
        name: "Jamón serrano",
        netMacro: 22,
        totalWeight: 60
    },
    LOMO: {
        name: "Lomo embuchado",
        netMacro: 22,
        totalWeight: 50
    },
    HUEVO: {
        name: "Huevo entero",
        netMacro: 22,
        totalWeight: 3 // 3 unidades de huevo
    },
    CLARA_HUEVO: {
        name: "Clara de huevo",
        netMacro: 22,
        totalWeight: 200
    },
    QUESO_LONCHAS: {
        name: "Queso lonchas light",
        netMacro: 22,
        totalWeight: 90
    },
    YOGUR_PROTEINAS: {
        name: "Yogur proteínas",
        netMacro: 22,
        totalWeight: 200
    },
    QUESO_COTTAGE: {
        name: "Queso cottage",
        netMacro: 22,
        totalWeight: 200
    },
    QUESO_DESNATADO: {
        name: "Queso fresco desnatado",
        netMacro: 22,
        totalWeight: 200
    },
    MOZZARELLA_LIGHT: {
        name: "Mozzarella light",
        netMacro: 22,
        totalWeight: 125
    },
    REAL_WHEY: {
        name: "Real Whey",
        netMacro: 22,
        totalWeight: 30
    },
    REAL_CASEIN: {
        name: "Real Casein",
        netMacro: 22,
        totalWeight: 30
    },
    TOFU: {
        name: "Tofu",
        netMacro: 22,
        totalWeight: 200
    },
    SOJA_TEXTURIZADA: {
        name: "Soja texturizada",
        netMacro: 22,
        totalWeight: 65
    }
};
